var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseX = function SvgCloseX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 8 4 4m4 4-4-4m0 0-4 4m4-4 4-4m-7.646-.354-.708.708L11.293 12l-3.647 3.646.708.708L12 12.707l3.646 3.647.708-.708L12.707 12l3.647-3.646-.708-.708L12 11.293Z"
  })));
};
export default SvgCloseX;